import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Field from '../../../../components/Form/Field'
import InternalLink from '../../../../components/InternalLink'
import RadioBlock from '../../../../components/Form/RadioBlock'

import { formatOptionsList } from '../../../../features/formatters'

import { getLocationLists } from '../../../../modules/actions/location'

import {
  locationListsLoadingSelector,
  locationListsSelector,
  locationListsWasLoadedSelector
} from '../../../../modules/selectors/location'

import { SHOW_OPTION, SHOW_OPTION_LOCATION_LIST, LOCATION_LIST } from '../fields'

import { ROUTES } from '../../../../constants/routes'

import useStyles from '../../../../styles/common/stepForms'

const Locations = ({ formik }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { values, errors, touched, setFieldValue } = formik

  const locationLists = useSelector(locationListsSelector)
  const locationListsWasLoaded = useSelector(locationListsWasLoadedSelector)
  const locationListsLoading = useSelector(locationListsLoadingSelector)

  // Do not show location list error if location list is empty
  const locationListError = useMemo(() => (locationLists.length ? errors[LOCATION_LIST] : ''), [locationLists, errors])
  const locationListTouched = touched[LOCATION_LIST]

  const formattedLocationsList = useMemo(
    () =>
      formatOptionsList({
        list: locationLists.map(list => ({
          ...list,
          name: `${list.name} (${list.size})`
        })),
        valueName: 'id',
        labelName: 'name'
      }),
    [locationLists]
  )

  useEffect(() => {
    // getLocationLists for SHOW_OPTION_LOCATION_LIST
    if (!locationListsWasLoaded && !locationListsLoading) {
      dispatch(getLocationLists())
    }
  }, [dispatch, locationListsWasLoaded, locationListsLoading])

  return (
    <RadioBlock
      setFieldValue={setFieldValue}
      id="radio_show_option_supermarkets_locations"
      name={SHOW_OPTION}
      value={SHOW_OPTION_LOCATION_LIST}
      selectedValue={values[SHOW_OPTION]}
      label={t('In proximity to specific stores or other locations')}
      error={locationListError}
      touched={locationListTouched}
    >
      <p>{t('Target the area around specific locations such as supermarkets you are stocked in.')}</p>
      {locationLists && !!locationLists.length ? (
        <Field
          placeholder={t('Select a locations list')}
          formik={formik}
          name={LOCATION_LIST}
          options={formattedLocationsList}
          showErrorMessage={false}
        />
      ) : (
        <p>
          {t(`To use this feature, you must have already uploaded the list of locations on the `)}
          <InternalLink className={classes.link} to={ROUTES.managePresets}>
            {t('settings')}
          </InternalLink>
          {t(' page.')}
        </p>
      )}
    </RadioBlock>
  )
}

export default Locations
